import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ButtonCheckbox', null, { withChildren: true });
